import { render, staticRenderFns } from "./ShowCharge.vue?vue&type=template&id=b15068c0&"
import script from "./ShowCharge.vue?vue&type=script&lang=js&"
export * from "./ShowCharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports